<template>
  <div>
    <NfseNacionalList v-if="ehAmbienteNacional" />
    <NfsePrefeituraList v-else />
  </div>
</template>

<script>

import { mapActions } from 'vuex'

import NfseNacionalList from './NfseNacionalList.vue'
import NfsePrefeituraList from './NfsePrefeituraList.vue'

export default {
  name: "NfseNacionalOuNfseMunicipal",
  data() {
    return {
      urlGetRegimeTributario: '/api/v1/tax-document/config-company/get-by-id',
      ehAmbienteNacional: false
    }
  },
  mounted() {
    this.obterRegimeTributarioEmpresa()
  },
  components: {
    NfseNacionalList,
    NfsePrefeituraList
  },
  methods: {
    ...mapActions('generic', ['getApi']),
    obterRegimeTributarioEmpresa() {
      let params = { url: this.urlGetRegimeTributario, obj: {} }
      this.getApi(params).then((response) => {
        if (response.success) {
          const data = response.content
          this.ehAmbienteNacional = data.nacional
        }
      })
    }
  }

};
</script>
